import enableExternalAuth from './utils/enable-external-auth';

export default [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ './views/LoginView.vue'),
    beforeEnter: enableExternalAuth(),
    meta: {
      privacy: 'guest-only',
      layout: 'LayoutLogin',
    },
  },

  {
    path: '/password/forgot',
    name: 'forgot-password',
    component: () => import(/* webpackChunkName: "login" */ './views/ForgotPasswordView.vue'),
    meta: {
      privacy: 'guest-only',
      layout: 'LayoutLogin',
    },
  },

  {
    path: '/password/reset',
    name: 'password-reset',
    component: () => import(/* webpackChunkName: "login" */ './views/PasswordResetView.vue'),
    meta: {
      privacy: 'guest-only',
      layout: 'LayoutLogin',
    },
  },
];
